<template>
    <div class="def-buy-one-click-thanks">
        <div v-if="messages.title" class="def-buy-one-click-thanks__title">
            {{ messages.title }}
        </div>
        <p v-if="messages.text" class="def-buy-one-click-thanks__text">
            {{ messages.text }}
        </p>
        <p v-if="messages.connect" class="def-buy-one-click-thanks__text">
            {{ messages.connect }}
        </p>
        <p v-if="messages.error" class="def-buy-one-click-thanks__error">
            {{ messages.error }}
        </p>

        <DefButtonPrimary @click="$DefModal.hide()">
            ОК
        </DefButtonPrimary>
    </div>
</template>

<script>
import DefButtonPrimary from "../DefButtonPrimary/DefButtonPrimary";
export default {
    name: 'DefBuyOneClickThanks',
    props: ['result'],
    components: {
        DefButtonPrimary,
    },
    computed: {
        messages() {
            return this.result?.messages;
        }
    }
}
</script>

<style lang="scss" scoped>
.def-buy-one-click-thanks{
    display: flex;
    flex-direction: column;
    //padding: 40px 16px;
    //@include point-md{
    //    padding: 46px 32px;
    //}
    &__title{
        font-weight: 500;
        font-size: rem(18);
        letter-spacing: 0.04em;
        text-transform: uppercase;
        margin-bottom: 24px;
    }
    &__text{
        font-weight: 400;
        font-size: rem(14);
        line-height: 130%;
        margin-bottom: 16px;
    }
    &__error{
        color: var(--color-red);
    }
    :deep(.def-button-primary) {
            margin-top: 8px;
    }
}
</style>